import React, { useState } from "react";
import { Colors, Images } from "../../global";
import {
  Group,
  Title,
  Button,
  Space,
  FileButton,
  Text,
  Paper,
  SimpleGrid,
  TextInput,
  Stack,
  Image,
  Center,
  NumberInput,
} from "@mantine/core";
import { MdKeyboardArrowLeft } from "react-icons/md";
import { Row } from "../../Components";
import { addProjectShare } from "../../API";
import { useAuthenticator } from "@aws-amplify/ui-react";
import {useRecoilValue} from 'recoil'
import { allSitesAtom } from "../../Atoms/allSitesAtom";
export const StoreAdd = (
  storeName,
  setStoreName,
  storeNumber,
  setStoreNumber,
  storeAddress,
  setStoreAddress,
  storeManager,
  setStoreManager,
  image,
  createStoreLoading,
  setCreateStoreLoading,
  handleImageUpload,
  repullStores,
  navigate,
  addProject,
  setImageUpdate
) => {
  const [storeCreated, setStoreCreated] = useState(false);
  const [addMemberLoading, setAddMemberLoading] = useState(false);
  const [teamEmail, setTeamEmail] = useState('');
  const { user } = useAuthenticator((context) => [context.user]);
  const allSites = useRecoilValue(allSitesAtom);


  // Add Store Function
  const handleAddStore = async (event) => {
    event.stopPropagation();
    setCreateStoreLoading(true);
    try {
      const res = await addProject({
        projectName: storeName,
        projectIdentifier: storeNumber,
        projectLocation: storeAddress,
      });
      console.log("addProject:", res);

      await handleImageUpload(res);
      await repullStores();
      setStoreCreated(true);
    } catch (err) {
      console.log("addProject:", err);
      setStoreCreated(false);
    } finally {
      setCreateStoreLoading(false);
    }
  };

  const handleAddShareStore = async () => {
    try {
      setAddMemberLoading(true);

      if (!user?.signInUserSession?.idToken?.jwtToken) {
        console.log("NO TOKEN!");
        return;
      } else {
        const res = await addProjectShare(
          user?.signInUserSession?.idToken?.jwtToken,
          allSites.stores.Items[0].project_id,
          teamEmail
        );

        console.log(
          "Member Added",
          res,
          user?.signInUserSession?.idToken?.jwtToken,
          allSites.stores.Items[0].project_id,
          teamEmail
        );
      }
    } catch (err) {
      console.log("handleAddShareStore Error:", err);
    } finally {
      setAddMemberLoading(false);
    }
  };

  return (
    <>
      <Group justify="space-between">
        <div>
          <Title order={2}>New Store</Title>
          <Text c="dimmed" size="sm">
            Enter store details.
          </Text>
        </div>

        <Button
          color={Colors.main}
          variant="outline"
          onClick={() => navigate("/users")}
          radius="sm"
          mr="md"
          h={43}
        >
          <MdKeyboardArrowLeft size="1.6rem" />
          <Text>Back To Stores</Text>
        </Button>
      </Group>

      <Space h="md" />

      <Paper p="md">
          <Row.ImageUpload
            title={"Store Image"}
            image={image ? image : Images.store}
            setImageUpdate={setImageUpdate}
          />
        
        <Space h="md" />
        
          <Stack>
            <TextInput
              label="Name"
              placeholder="Enter Store Name"
              styles={{
                input: { backgroundColor: Colors.gray100 },
              }}
              value={storeName}
              onChange={(event) => setStoreName(event.currentTarget.value)}
            />

            <NumberInput
              label="Store Number"
              placeholder="Enter Store Name"
              styles={{
                input: { backgroundColor: Colors.gray100 },
              }}
              value={storeNumber}
              onChange={setStoreNumber}
              hideControls
              allowDecimal={false}
              allowNegative={false}
            />

            <TextInput
              label="Store Address"
              placeholder="123 Any Street, City, State 00000"
              styles={{
                input: { backgroundColor: Colors.gray100 },
              }}
              value={storeAddress}
              onChange={(event) => setStoreAddress(event.currentTarget.value)}
            />
          </Stack>
        <Space h="md" />

        <Group justify="flex-end">
          <Button
            color={Colors.main}
            loading={createStoreLoading}
            onClick={handleAddStore}
            disabled={
              !storeName || !storeAddress || !storeNumber
            }
          >
            Create Store
          </Button>
        </Group>
      </Paper>

      <Space h="md" />

      <Paper p="md">
        <Text size="xl" fw={500}>
          Team Members
        </Text>
        <Space h="md" />
        <Group gap="lg">
          <TextInput
            placeholder="example@email.com"
            styles={{
              input: { backgroundColor: Colors.gray100 },
            }}
            disabled={!storeCreated}
            value={teamEmail}
            onChange={(event) => setTeamEmail(event.currentTarget.value)}
          />

          <Button
            color={Colors.main}
            disabled={!storeCreated}
            loading={addMemberLoading}
            onClick={handleAddShareStore}
          >
            Add
          </Button>
        </Group>
      </Paper>
    </>
  );
};

export default StoreAdd;
